import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {CheckpointResult} from '../classes/checkpoint-result';
import {RealtimeService} from './realtime/realtime.service';
import {WebsocketService} from './websocket/websocket.service';
import {RealtimeType} from './realtime/realtime-type.enum';
import {CheckpointResultContent} from '../classes/checkpoint-result-content';

@Injectable({
    providedIn: 'root'
})
export class CheckpointResultService extends RealtimeService<CheckpointResult> {

    constructor(public apiService: ApiService, protected websocketService: WebsocketService) {
        super(websocketService, RealtimeType.checkpoint_results);
    }

    getCheckpointResult(id: number) {
        return this.apiService.getCallData$<CheckpointResult>(`checkpoints/results/${id}`);
    }

    getCheckpointResults(checkpointId: number) {
        return this.apiService.getCallData$<CheckpointResult[]>(`checkpoints/${checkpointId}/results`);
    }

    getCheckpointResultContent(hash: string) {
        return this.apiService.getCallData$<CheckpointResultContent>(`checkpoints/results/content/${hash}`);
    }

    itemInDaterange(planning: CheckpointResult, fromDate: Date, toDate: Date) {
        return true;
    }
}
